//import { useTheme } from "@emotion/react";

//const theme = useTheme();

export const labelStyled = {
  fontSize: "1rem",
  lineHeight: "24.5px",
  color: "primary.main",
  textTransform: "capitalize",
};
export const groupStyled = {
  gap: "1rem",
  width: "100%",
};
export const groupStyled2 = {
  gap: "1rem",
  flexBasis: "100%",
};
export const columnCentered = {
  ...groupStyled,
  display: "flex",
  flexDirection: "column",
  gap: "2rem",

  //alignItems: "center",
  //justifyContent: "center",
};
export const column = {
  display: "flex",
  flexDirection: "column",
  gap: "1.8rem",
  width: "100%",
};
export const row = {
  display: "flex",
  flexDirection: "row",
  gap: "1.1rem",
  width: "100%",
  flexWrap: "wrap",
  //flexWrap: "wrap",
};
export const rowFlex = {
  ...row,
  width: "20%",
  flexDirection: "column",
  //gap: "5rem",
  flexWrap: "wrap",

  justifyContent: "space-between",
};
export const col = {
  display: "flex",
  flexDirection: "column",
  gap: "1.8rem",
  width: "50%",
  padding: "40px 0px",
};
export const formGroupContainer = {
  display: "flex",
  gap: "1.8rem",
  width: "100%",
};
export const header = {
  //border: "1px solid black",
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};
export const leftCol = {
  display: "flex",
  flexDirection: "column",
  width: "50%",
  gap: "1.8rem",
};
